var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6496 15C54.7246 15.875 52.6496 16.45 50.4996 16.725C52.6996 15.4 54.3996 13.3 55.1996 10.775C53.1246 12.025 50.8246 12.9 48.3996 13.4C46.4246 11.25 43.6496 10 40.4996 10C34.6246 10 29.8246 14.8 29.8246 20.725C29.8246 21.575 29.9246 22.4 30.0996 23.175C21.1996 22.725 13.2746 18.45 7.99961 11.975C7.07461 13.55 6.54961 15.4 6.54961 17.35C6.54961 21.075 8.42461 24.375 11.3246 26.25C9.54961 26.25 7.89961 25.75 6.44961 25V25.075C6.44961 30.275 10.1496 34.625 15.0496 35.6C13.4764 36.0305 11.8248 36.0904 10.2246 35.775C10.9036 37.9062 12.2335 39.771 14.0272 41.1073C15.8208 42.4436 17.9882 43.1842 20.2246 43.225C16.4337 46.2261 11.7346 47.8483 6.89961 47.825C6.04961 47.825 5.19961 47.775 4.34961 47.675C9.09961 50.725 14.7496 52.5 20.7996 52.5C40.4996 52.5 51.3246 36.15 51.3246 21.975C51.3246 21.5 51.3246 21.05 51.2996 20.575C53.3996 19.075 55.1996 17.175 56.6496 15Z",
    fill: "#80FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "homepage/static/media/twitter.3d8646a7b7adcfe54fd06a63e2f1c65c.svg";
export { ForwardRef as ReactComponent };